// extracted by mini-css-extract-plugin
export var arrow = "_3d-6";
export var changeItem = "_3d-3";
export var changesHeader = "_3d-1";
export var changesList = "_3d-2";
export var container = "_3d-0";
export var pathLabel = "_3d-4";
export var value = "_3d-7";
export var valuesContainer = "_3d-5";